import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function ConfirmDialog(props={}) {
  return (
    <div>
      <Dialog
        open={props.open}
        onClose={props.hideDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {props.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.text}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant={props.noButtonVariant || "outlined"} style={props.noButtonStyle} onClick={props.hideDialog}>{props.noLabel ? props.noLabel : "No"}</Button>
          <Button variant={props.yesButtonVariant || "contained"} style={props.yesButtonStyle} onClick={props.handleConfirm}>{props.yesLabel ? props.yesLabel : "Yes"}</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}